import { render, staticRenderFns } from "./iconsGroup.vue?vue&type=template&id=550530c8&scoped=true&"
import script from "./iconsGroup.vue?vue&type=script&lang=js&"
export * from "./iconsGroup.vue?vue&type=script&lang=js&"
import style0 from "./iconsGroup.vue?vue&type=style&index=0&id=550530c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550530c8",
  null
  
)

export default component.exports